import Vue from 'vue';
import watchSDK from '@wanxin-site/watch-sdk-vue';

// 模块级标志位，确保 SDK 仅初始化一次
let initialized = false;

// 根据当前域名 / 编译变量判断运行环境
const getEnv = () => {
  if (process.env.VUE_APP_IS_TEST) return 'test';
  const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
  if (host.includes('test')) return 'test';
  if (host.includes('pre')) return 'pre';
  return 'prod';
};

const REPORT_TEST_URL = 'https://monitor-api-server.hzwxbz999.cn/api/v1/report';
const REPORT_PROD_URL = 'https://monitor-api-server.hzwxbz2.cn/api/v1/report';

/**
 * 初始化前端监控 SDK
 * 仅在首次调用且传入有效 uid 时执行真正的初始化，后续调用会被忽略
 * @param {string|number} uid 用户唯一标识（来自 userInfo.id）
 */
export const initMonitor = (uid) => {
  if (initialized) return;
  if (!uid) return;

  try {
    watchSDK.instance({
      app: Vue,
      uid: String(uid),
      pid: 520,
      projectType: 'h5',
      env: getEnv(),
      REPORT_URL: getEnv() === 'prod' ? REPORT_PROD_URL : REPORT_TEST_URL,
    });
    initialized = true;
  } catch (err) {
    // 监控初始化失败不应影响业务，仅打印日志
    console.warn('[monitor] init failed:', err);
  }
};

export const isMonitorInitialized = () => initialized;
